const isFunction = (functionToCheck) => {
    return (
        functionToCheck &&
        ({}.toString.call(functionToCheck) === '[object Function]' ||
            {}.toString.call(functionToCheck) === '[object Promise]')
    )
}

export default isFunction
